<template>
  <v-container>
    <v-layout>
      <v-flex xs12 sm8 md4>
        <v-card class="elevation-12">
          <v-toolbar dark color="primary">
            <v-toolbar-title>Configuración operador SMS</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>
            <v-form>
              <v-select
                :items="cfg.operators"
                v-model="cfg.operatorSelected"
                label="Operador"
              ></v-select>
              <v-text-field
                v-if="cfg.operatorSelected === cfg.operators[1]"
                prepend-icon="phone"
                name="tlf"
                label="Teléfono"
                type="text"
                :counter="11"
                maxlength="11"
                v-model="cfg.operatorTlf"
              ></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="saveForm">Guardar</v-btn>
          </v-card-actions>
        </v-card>
        <v-alert v-model="alert" dismissible type="error">
          {{ errorMessage }}
        </v-alert>
      </v-flex>
    </v-layout>
    <!-- <pre>{{ smsConfig }}</pre>
    <pre>{{ cfg }}</pre> -->
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "ConfigSMS",
  data: () => ({
    cfg: {
      operatorTlf: null,
      operatorSelected: null,
      operators: []
    },
    alert: false,
    errorMessage: ""
  }),

  created() {
    this.cfg = Object.assign({}, this.smsConfig)
  },

  computed: {
    ...mapGetters(["smsConfig"]),
  },

  methods: {
    ...mapActions(["setConfigSms"]),

    saveForm() {
      console.log(this.cfg)
      this.setConfigSms(this.cfg)
    }
  }
}
</script>

<style>

</style>